import ACTIONS from './actions';
import { invalidateFieldBindingCache } from '../binding/lookup';

var onPageChange = function onPageChange(value, dispatch) {
  dispatch({
    type: ACTIONS.SET_ACTIVE_PAGE,
    payload: value
  });
};

var onMetaPropChanged = function onMetaPropChanged(fieldId, name, value, dispatch) {
  dispatch({
    type: ACTIONS.SET_FIELD_META,
    payload: {
      fieldId: fieldId,
      name: name,
      value: value
    }
  });
};

var onChange = function onChange(fieldId, value, dispatch) {
  invalidateFieldBindingCache(fieldId);
  dispatch({
    type: ACTIONS.SET_FIELD_VALUE,
    payload: {
      fieldId: fieldId,
      value: value
    }
  });
  dispatch({
    type: ACTIONS.UPDATE_VISIBILITY,
    payload: [fieldId]
  });
  dispatch({
    type: ACTIONS.FORM_DATA_CHANGED
  });
};

var onRepeatingChange = function onRepeatingChange(fieldId, value, dispatch) {
  dispatch({
    type: ACTIONS.SET_REPEATING_FIELD_VALUE,
    payload: {
      fieldId: fieldId,
      value: value
    }
  });
  dispatch({
    type: ACTIONS.UPDATE_VISIBILITY,
    payload: [fieldId]
  });
  dispatch({
    type: ACTIONS.FORM_DATA_CHANGED
  });
};

var onFocus = function onFocus(fieldId, dispatch) {
  dispatch({
    type: ACTIONS.SET_FIELD_TOUCHED,
    payload: {
      fieldId: fieldId
    }
  });
};

var onBlur = function onBlur(fieldId, dispatch) {
  dispatch({
    type: ACTIONS.SET_FIELD_BLURED,
    payload: {
      fieldId: fieldId
    }
  });
};

export default {
  onMetaPropChanged: onMetaPropChanged,
  onPageChange: onPageChange,
  onRepeatingChange: onRepeatingChange,
  onChange: onChange,
  onFocus: onFocus,
  onBlur: onBlur
};